import { actionCreator } from '@ardoq/rxbeach';
import type {
  FutureStateEditValueChangedPayload,
  OpenFutureStateFieldEditPayload,
  UpdateFutureStatePayload,
} from './types';

const DOMAIN = '[transformations.futureStatePageForm]';

export const futureStateFieldEditOpened =
  actionCreator<OpenFutureStateFieldEditPayload>(
    `${DOMAIN} FUTURE_STATE_FIELD_EDIT_OPENED`
  );

export const futureStateFieldEditClosed = actionCreator(
  `${DOMAIN} FUTURE_STATE_FIELD_EDIT_CLOSED`
);

export const futureStateFieldValueChanged =
  actionCreator<FutureStateEditValueChangedPayload>(
    `${DOMAIN} FUTURE_STATE_FIELD_VALUE_CHANGED`
  );

export const updateFutureStateRequested =
  actionCreator<UpdateFutureStatePayload>(
    `${DOMAIN} UPDATE_FUTURE_STATE_REQUESTED`
  );
